import { useEffect } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router';
import { Toaster } from 'sonner';

import { CartDrawer } from '../commerce/CartDrawer';
import { Footer } from './Footer';
import { Header } from './Header';
import { AnnouncementBar } from './AnnouncementBar';
import { FloatingWhatsApp } from './FloatingWhatsApp';

export function RootLayout() {
  const { pathname } = useLocation();

  // Move keyboard focus to the top on navigation — ScrollRestoration only
  // handles the scroll position, not where the next Tab press lands.
  useEffect(() => {
    document.getElementById('conteudo')?.focus({ preventScroll: true });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-xl focus:bg-brown-900 focus:px-4 focus:py-3 focus:font-display focus:text-sm focus:font-bold focus:text-cream-100"
      >
        Pular para o conteúdo
      </a>

      <AnnouncementBar />
      <Header />

      <main id="conteudo" tabIndex={-1} className="flex-1 outline-none">
        <Outlet />
      </main>

      <Footer />

      <CartDrawer />
      <FloatingWhatsApp />

      <ScrollRestoration />

      <Toaster
        // No topo: embaixo, o aviso cobria o botão de enviar a lista na
        // gaveta e o botão flutuante do WhatsApp.
        position="top-center"
        offset={80}
        toastOptions={{
          classNames: {
            toast:
              'font-sans rounded-2xl border-2 border-sand-300 bg-white text-brown-900 shadow-card-hover',
            title: 'font-display font-bold text-sm',
            description: 'text-brown-700 text-xs',
            // `!` overrides Sonner's own inline button styles.
            actionButton:
              'font-display !bg-orange-500 !text-white rounded-lg px-3 py-1.5 text-xs font-bold',
          },
        }}
      />
    </div>
  );
}
